import { createFileRoute } from "@tanstack/react-router";
import AdminCriterionTopicsPage from "@/pages/admin/criterion-topics";

export const Route = createFileRoute("/app/admin/criterion-topics")({
  component: AdminCriterionTopicsPage,
});
